module.exports = __webpack_public_path__ + "static/media/vivi-explicando-direita.dcadeb02.svg";